export default {
  de: {
    general: {
      customer: "Kunde",
      product_group: "Produktgruppe",
      id: "ID",
      name: "Name",
      actions: "Actions",
      reports: "Prüfberichte",
      report: "Prüfbericht",
      products: "Produkte",
      unit: "Einheit",
      format: "Typ",
      category: "Kategorie",
      shortcut: "Abkürzung",
      waiting: "Warten",
      in_progress: "In Arbeit",
      text: "Text",
      delete: "Löschen",
      move: "Bewegen",
      completed: "Veröffentlicht",
      confirm: "Bestätigen",
      cancel: "Abbrechen",
      save: "Speichern",
      saving: "Speichert...",
      save_order: "Speicherreihenfolge",
      edit: "Bearbeiten",
      remove: "Entfernen",
      clear: "Leeren",
      select: "Auswählen",
      search: "Suchen",
      overwrite: "Überschreiben",
      created: "Angelegt",
      date: "Datum",
      please_wait_data_from_cedoon: "Bitte warten, bis CEDOON die Daten geladen hat.",
      loading_data: "Daten werden geladen...",
      deleting: "Wird gelöscht...",
      copied_to_clipboard: "In die Zwischenablage kopiert",
      supervisor_name: "Names des QC Managers",
      measurements: "Messungen",
      sheets: "Blätter",
      min: "min",
      max: "max",
      test_template: "Prüfanweisung",
      value_required: "Wert erforderlich",
      oder: "or",
      boolean: "boolean",
      optional: "optional",
      order: "Reihenfolge",
      print: "Drucken",
      email: "E-Mail",
      password: "Passwort",
      base_data: "Basisdaten",
      search_criteria: "Suchkriterium",
      von: "from",
      bis: "to",
      data: "Daten",
      select_or_drop_file_here: "Datei auswählen",
      error: {
        error: "Fehler",
        title: "Ein Fehler ist passiert.",
        generic_error: "Bitte versuchen Sie es später noch einmal.",
        loading_data: "Fehler beim Laden der Daten",
        id_doesnt_exist: "ID existiert nicht oder es liegt ein anderes Problem vor.",
        oops: "Hoppla, das hätte nicht passieren dürfen.",
        communication_error:
          "Es ist ein Kommunikationsproblem aufgetreten. Bitte prüfen Sie die Internetverbindung und kontaktieren Sie den Administrator."
      },
      success: "Erfolgreich verarbeitet!",
      administration: "Administration",
      files: "Upload Dateien",
      drop_file_here: "Datei hier herziehen oder klicken zum Auswählen.",
      description: "Beschreibung",
      submit_report: "Prüfbericht abschicken",
      complete_report: "Prüfbericht veröffentlichen",
      critical: "Kritisch",
      max_diff: "Max. Δ"
    },
    portal: {
      page_header: "Kopfbereich",
      logout: "Logout",
      dashboard: "Dashboard",
      create_report: "Prüfbericht anlegen",
      manage_reports: "Prüfberichte verwalten",
      search_reports: "Prüfberichte suchen",
      view_report: "Prüfbericht ansehen",
      change_language: "Sprache"
    },
    login: {
      credentials_dont_match: "Die Kriterien treffen auf keinen Prüfbericht zu.",
      login: "Login",
      enter_email: "Bitte geben Sie Ihre E-Mailadresse ein.",
      enter_password: "Bitte geben Sie Ihr Passwort ein."
    },
    reports_index: {
      create_new: "Neuen Prüfbericht anlegen",
      no_reports_waiting: "Kein Prüfbericht 'WARTET'",
      no_reports_in_progress: "Kein Prüfbericht 'IN ARBEIT'",
      no_reports_completed: "Kein Prüfbericht 'VERÖFFENTLICHT'",
      measurements_done: "Datenerfassung abgeschlossen",
      no_reports_finished_measurement: "Kein Prüfbericht 'DATEN ERFASST'",
      no_reports_found: "Kein Prüfbericht gefunden",
      dialog: {
        delete_message: "Möchten Sie wirklich <strong>{report_number} - {report_name}</strong> löschen?"
      }
    },
    reports_search_list: {
      test_report_list: "Prüfberichtsliste"
    },
    report: {
      report_information: "Prüfberichtsinformation",
      report_no: "Prüfberichtsnr.",
      description: "Prüfberichtsbeschreibung",
      customer_name: "Kundenname",
      customer_order_no: "Kundenbestellnr.",
      supplier_name: "Herstellername",
      supplier: "Hersteller",
      plant: "Herstellwerk",
      shipping_date: "Verschiffungsdatum",
      order_date: "Bestelldatum",
      checked_with: "Geprüft nach",
      product_information: "Produktinformation",
      article_no: "Artikelnr.",
      charge: "Chargen-Nr.",
      surface: "Oberfläche",
      head: "Kopf",
      head_stamp: "Kopfstempel",
      recess: "Antrieb",
      recess_size: "Antriebsgröße",
      thread_type: "Gewindetyp",
      point: "Spitze",
      drawing_no: "Zeichnungsnr.",
      batch: "Chargen-Nr.",
      material_certificate: "Materialzertifikat",
      heat_nr: "Heat Nr.",
      order_quantity: "Bestellmenge",
      sheet_amount: "(kein Blatt) | (1 Blatt) | ({amount} Blätter)",
      wood_information: {
        wood_information: "Holzinformation",
        wood_no: "Holznr.",
        insertion_direction: "Einschraubrichtung",
        wood_moisture: "Holzfeuchte",
        wood_density: "Holzdichte",
        room_temperature: "Raumtemperatur",
        room_moisture: "Raumfeuchte"
      },
      progress: "Fortschritt",
      customer: "Kunde",
      data_validation: "Testergebnis",
      attachments_for: "Anhänge für",
      loading_report: "Prüfbericht wird geladen...",
      loading_reports: "Prüfberichte werden geladen...",
      error_loading_report: "Fehler beim Laden des Prüfberichts",
      template: "Prüfanweisung",
      sales_contract: "Sales Contract",
      screw_type: "Schraubentyp",
      screw_diameter: "Schraubendurchmesser",
      screw_length: "Schraubenlänge",
      no_samples: "Musternr.",
      customer_drawing_number: "Kundenzeichnungsnr.",
      work_order_nr: "Auftragsnr.",
      attachments: "Anhänge",
      no_attachments: "Es existieren keine Anhänge für diesen Prüfbericht.",
      no_attachments_sheet: "Es existieren keine Anhänge für dieses Prüfberichtsblatt.",
      upload: {
        title: "Upload Datei",
        wrong_file_type: "Falscher Dateityp (nur PNG/JPG/PDF)",
        upload_file: "Upload Datei"
      },
      success: {
        measurements: {
          message: "Testdaten erfolgreich gespeichert."
        },
        info: {
          message: "Prüfberichtsinformation erfolgreich gespeichert."
        },
        wood_info: {
          message: "Holzsinformation erfolgreich gespeichert."
        },
        sheet_info: {
          message: "Prüfberichtsblattinformationen erfolgreich gespeichert."
        }
      }
    },
    reports_show: {
      dialog: {
        message: "Wollen Sie diesen Anhang wirklich löschen?"
      },
      no_report_found: "Kein Prüfbericht gefunden",
      no_report_found_url: "Kein Prüfbericht mit dieser URL gefunden"
    },
    reports_create: {
      heading: "Prüfbericht anlegen",
      configure_heading: "Prüfbericht konfigurieren",
      report_data: "Prüfberichtsdaten",
      report_data_description: "Bitte geben Sie die Basisdaten für den Prüfbericht ein.",
      checking_report_number: "Prüfberichtsnummer wird überprüft",
      number_in_use: "Diese Nummer wird bereits verwendet.",
      use_instead: "Bitte stattedessen {number} verwenden.",
      number_available: "Diese Nummer ist verfügbar.",
      add_product: "Produkt hinzufügen",
      select_products: "Bitte wählen Sie die Produkte für den Prüfbericht aus.",
      bulk_import_measurements: "Bulk-Import von Messdaten",
      select_test_template: "Bitte wählen Sie eine Prüfanweisung aus.",
      import_measurements: "Einzel-Import von Messdaten für ein Produkt.",
      some_characteristics_wont_be_imported:
        "Einige Prüfkriterien sind in der Uploaddatei nicht vorhanden und werden nicht importiert (orange gekennzeichnet).",
      overwrite_dialog: {
        message:
          "Dieser Prüfbericht enthält bereits Messdaten.<br/> Wollen Sie die bestehenden Daten <strong>überschreiben</strong>?"
      },
      bulk_overwrite_dialog: {
        message:
          "Für die folgenden Produkte sind im Prüfbericht bereits Messdaten vorhanden.<br/> Wollen Sie die bestehenden Daten für alle Produkte <strong>überschreiben</strong>?"
      },
      delete_dialog: {
        message:
          "Für dieses Produkt sind ev. bereits Daten erfasst worden.<br/> Wollen Sie das Produkt trotzdem <strong>löschen</strong>?",
        success: "Prüfberichtsblatt erfolgreich gelöscht",
        error:
          "Während des Löschens des Prüfberichtsblattes ist ein Fehler passiert. Bitte versuchen Sie es noch einmal oder wenden Sie Sich an Ihren Administrator."
      }
    },
    reports_search: {
      heading: "Prüfberichte suchen"
    },
    reports_view: {
      heading: "Prüfbericht ansehen",
      enter_charge_and_article_no: "Bitte geben Sie die Chargennummer und die Artikelnummer ein!",
      select_at_least_one_characteristic: "Bitte wählen Sie mindestens 1 Prüfkriterium."
    },
    reports_print: {},
    products: {
      description: "Produktbeschreibung",
      import: "Import Produkte",
      add_new: "Neues Produkt hinzufügen",
      loading_products: "Produkte werden geladen...",
      no_products_available: "Keine Produkte verfügbar",
      no_products_found: "Keine Produkte gefunden",
      start_by_adding_new_products: "Bitte starten Sie damit, Produkte hinzuzufügen.",
      error_deleting:
        "Während des Löschens des Produktes ist ein Fehler passiert. Bitte versuchen Sie es noch einmal oder wenden Sie Sich an Ihren Administrator.",
      success_deleting: "Produkt erfolgreich gelöscht",
      deletion_text: "Wollen Sie <strong>{description}</strong> wirklich löschen?",
      use_proposed_value: 'Vorgeschlagene Produktbeschreibung verwenden "{description}"'
    },
    products_edit: {
      heading: "Produkt bearbeiten",
      master_data: "Stammdaten",
      assign_test_template: "Prüfanweisung zuweisen",
      add_test_template: "Prüfanweisung hinzufügen",
      range_value: "Bereich / Wert",
      no_test_templates: "Keine Prüfanweisung verfügbar",
      test_template_remove_try_dialog: {
        message: "Diese Prüfanweisung wird in einem Prüfbericht verwendet und kann daher nicht gelöscht werden."
      },
      remove_template_dialog: {
        message:
          "Möchten Sie die Zuordnung der Prüfanweisung <strong>' + {templateName} + '</strong> wirklich von diesem Produkt entfernen?<br/>Dieser Schritt wird sofort durchgeführt und kann nicht zurückgenommen werden."
      }
    },
    products_create: {
      heading: "Produkt anlegen",
      enter_properties: "Produktdaten eingeben"
    },
    products_import: {
      heading: "Import Produktdaten und Toleranzen",
      step_1: "Schritt 1 - Import Produkte",
      import_data: "Datenimport",
      importing_data: "Daten werden importiert...",
      import_successful: "Import erfolgreich!",
      need_help: "Brauchen Sie Hilfe?",
      need_help_text_columns_allowed:
        "Folgende Spalten sind erlaubt {column} (das bedeutet, dass diese Spalten mehrfach vorkommen können)",
      need_help_text_columns_required: "Die folgenden Spalten müssen in der Importdatei vorkommen.",
      step_2: "Schritt 2 - Import Toleranzen",
      article_number_of_product: "Artikelnummer des Produktes",
      which_template: "die Prüfanweisung, die verwendet wird",
      shorthand_of_characteristic: "Abkürzung des Prüfkriteriums",
      target_value: "Zielwert",
      ok_nok_field: "ok/nok-Feld",
      sequence_of_characteristics: "Reihenfolge, in der die Prüfkriterien erscheinen",
      "Schlüssel des Prüfkriteriums": "characteristic_key",
      validate: "Datenvalidierung",
      is_validating: "Daten werden validiert...",
      errors_occurred:
        "Es wurden Fehler gefunden. Bitte prüfen Sie die Tabelle unten und importieren Sie die Daten neu, nachdem alle Fehler behoben wurden.",
      clear: "Leeren",
      errors: {
        MISSING_REQUIRED_PROPERTY: "Verpflichtendes Prüfkriterium fehlt",
        UNALLOWED_MULTIPLE_VALUES: "Mehrfachdaten für einmaliges Prüfkriterium gefunden",
        UNKNOWN_VALUE: "Falscher Wert für Prüfkriterium gefunden",
        COMPANY_DOES_NOT_EXIST: "Firma existiert nicht",
        PRODUCT_EXISTS: "Produkt mit angegebener Artikelnummer- und Kundenkombination existiert bereits",
        TEMPLATE_DOES_NOT_EXIST: "Prüfanweisung existiert nicht",
        PRODUCT_DOES_NOT_EXIST: "Produkt existiert nicht",
        CHARACTERISTIC_NOT_ASSIGNED: "Prüfkriterium ist der Prüfanweisung nicht zugeordnet",
        UNKNOWN_CHARACTERISTIC: "Unbekannte Characteristics-ID gefunden"
      }
    },
    products_search: {
      choose_products: "Produkt auswählen",
      add_selected_products: "Ausgewählte Produkte hinzufügen",
      multiple_customers_error: "Sie können nur Produkte desselben Kunden hinzufügen"
    },
    calculation: {
      rtor_k1: "Charak. Einschraub-DM_5",
      rtor_k2: "Charakt. Einschraub-DM_95",
      rtor_mw: "Durchschn. Einschraub-DM_avg",
      ftor_k1: "Charakt. Bruch-DM",
      fax_k1: "Charakt. Ausziehparam.",
      my_k1: "Charakt. Fließmoment",
      fhead_k1: "Charakt. Kopfdurchz.param.",
      ftens_k1: "Charakt. Zugfestigkeit",
      tor_rat_1: "Torsionsverhältnis_5",
      tor_rat_2: "Torsionsverhältnis_95",
      tor_rat_3: "Torsionsverhältnis_avg",
      ftor_k1_raw: "Charakt. Bruch-DM_raw",
      rtor_k1_raw: "Charak. Einschraub-DM_5raw)",
      rtor_k2_raw: "Charak. Einschraub-DM_95raw",
      rtor_mw_raw: "Durchschn. Einschraub-DM_avgraw"
    },
    characteristics: {
      product_characteristics: "Prüfkriterien",
      characteristic: "Prüfkriterium",
      characteristics: "Prüfkriterien",
      assign_characteristics: "Prüfkriterien zuweisen",
      assigned_characteristics: "Zugewiesene Prüfkriterien",
      loading_characteristics: "Prüfkriterien werden geladen...",
      already_in_use: "Dieses Prüfkriterium wird bereits verwendet und kann daher nicht gelöscht werden.",
      available_characteristics: "Verfügbare Prüfkriterien",
      critical_characteristic: "Kritische Prüfkriterien"
    },
    characteristics_index: {
      add_new: "Neues Prüfkriterium erstellen",
      no_characteristics_available: "Keine Prüfkriterien verfügbar",
      start_by_adding_new_characteristics: "Beginnen Sie damit, neue Prüfkriterien hinzuzufügen",
      dialog: {
        message: "Wollen Sie wirklich <strong>{localizedKey}</strong> löschen?"
      }
    },
    characteristics_create: {
      heading: "Neues Prüfkriterium erstellen",
      error_while_creating: "Während der Erstellung eines neuen Prüfkriteriums ist ein Fehler passiert"
    },
    templates_index: {
      create_new: "Neue Prüfanweisung erstellen",
      loading_templates: "Prüfanweisungen werden geladen...",
      no_templates_available: "Keine Prüfanweisungen verfügbar",
      start_by_adding_a_new_template: "Beginnen Sie damit, eine neue Prüfanweisung hinzuzufügen"
    },
    templates_create: {
      create_new: "Neue Prüfanweisung erstellen",
      selected_characteristics: "Ausgewählte Prüfanweisungen",
      available_characteristics: "Verfügbare Prüfanweisungen"
    },
    template_view: {
      title: "Prüfanweisung: {name}",
      info_text: "Sie können die Reihenfolge der Prüfkriterien mittels 'Drag & Drop' anpassen.",
      assigned_characteristics: "Zugewiesene Prüfkriterien",
      loading: {
        title: "Prüfanweisung wird geladen...",
        subtitle: "Bitte warten, bis CEDOONB die Prüfanweisung geladen hat.",
        error: {
          title: "Während des Ladens der Prüfanweisung ist ein Fehler passiert.",
          subtitle: "ID existiert nicht oder es liegt ein anderes Problem vor."
        }
      },
      saving: {
        success: "Neue Reihenfolge der Prüfkriterien erfolgreich gespeichert.",
        button: "Reihenfolge der Prüfkriterien speichern"
      }
    },
    characteristic_titles: {
      report_number: "Prüfbericht Nr.",
      screw: "Schraube",
      test_acc: "Prüfung gemäß",
      valid_from: "Gültig ab",
      supplier_name: "Lieferantenname",
      sales_contract: "Auftragsbestätigung",
      shipping_date: "Verschiffungsdatum",
      size: "Abmessung",
      work_order: "Arbeitsauftrag",
      customer_name: "Kundenname",
      head: "Kopf",
      thread: "Gewinde",
      point: "Spitze",
      recess: "Antrieb",
      customer_order_name: "Kundenbestellnr.",
      surface: "Beschichtung",
      drawing_no: "Zeichnungsnr.",
      head_mark: "Kopfstempel",
      article_number: "Artikelnr.",
      batch: "Chargen-Nr.",
      material_certificate: "Materialzertifikat",
      heat_no: "Heat Nr.",
      insp_items: "Messkriterien",
      shippment_date: "Verschiffungsdatum",
      wood_nr: "Holz-Nr.",
      insertion_direction: "Einschraubrichtung",
      wood_moisture: "Holzfeuchte",
      wood_density: "Holzdichte",
      room_temperature: "Raumtemperatur",
      room_moisture: "Raumfeuchte"
    },
    data_types: {
      TEXT: "Text je Muster",
      FLOAT: "Zahl je Muster ",
      BOOLEAN: "2er-Auswahl (OK/NOK) je Muster",
      ONE_BOOLEAN_PER_CHARACTERISTIC: "2er-Auswahl (OK/NOK) je Prüfkriterium",
      ONE_FLOAT_PER_CHARACTERISTIC: "Zahl je Prüfkriterium",
      ONE_BOOLEAN_PER_PRODUCT: "2er-Auswahl (OK/NOK) je Produkt",
      ONE_TEXT_PER_PRODUCT: "Text je Produkt"
    },
    file_upload: {
      title: "Upload Datei",
      category_file: "Kategorie und Datei auswählen.",
      category: "Kategorie",
      file_name: "Dateiname",
      mc: "Materialzertifikat",
      company: "Firma",
      dropzone: {
        text: "Datei hier herziehen oder klicken zum Auswählen.",
        allowed_file_types: "Erlaubte Dateitypen: {types}",
        wrong_file_type: "Dateityp nicht erlaubt",
        please_select: "Datei hier herziehen oder klicken zum Auswählen."
      },
      saving: {
        button: "Upload",
        error: "Fehler während des Uploads. Bitte versuchen Sie es erneut.",
        success: "Dateiupload erfolgreich ",
        file_exists: "Datei mit diesem Namen existiert bereits"
      }
    },
    files: {
      loading: {
        title: "Dateien werden geladen...",
        subtitle: "Bitte warten, bis CEDOON die Dateien geladen hat.",
        error: {
          title: "Fehler beim Laden der Dateien.",
          subtitle: "Bitte versuchen Sie es erneut."
        }
      },
      title: "Upload Dateien",
      header: {
        file_name: "Dateiname",
        category: "Kategorie",
        uploaded_by: "Geladen von"
      }
    },
    print_report_dialog: {
      title: "Als PDF speichern",
      subtitle: "Einstellungen",
      layout: "Layout",
      language: "Sprache",
      save: "PDF speichern",
      open: "PDF öffnen",
      send: "PDF senden",
      recipient: "Empänger-Emailadresse",
      recipient_text: "Bitte geben Sie die Empänger-Emailadresse ein",
      recipient_valid_email: "Bitte geben Sie eine gültige Emailadresse ein!",
      attachments: {
        title: "Attachments anhängen",
        pdf: "PDF Attachments",
        image: "Bild-Attachments",
        characteristic: "Characteristics-Attachments",
        material_certificate: "Materialzertifikat",
        technical_drawing: "Technische Zeichnung"
      }
    },
    layouts: {
      STANDARD: "Standard",
      DECKMATE: "Deckmate",
      DEMO: "Demo"
    },
    submit_report: {
      error: "Bitte geben Sie Ihren Namen ein.",
      text:
        "Bitte geben Sie Ihren Namen ein, um den Prüfbericht abzuschicken. Nach dem Abschicken können Sie den Bericht nicht mehr ändern.",
      success: "Prüfbericht erfolgreich abgeschickt"
    },
    report_step: {
      CREATED: "Warten",
      IN_PROGRESS: "In Arbeit",
      DONE_GATHERING: "Datenerfassung abgeschlossen",
      COMPLETED: "Veröffentlicht"
    },

    report_filter: {
      heading: "Prüfberichte filtern",
      timeframe: "Zeitspanne",
      one_week: "1 Woche",
      one_month: "1 Monat",
      one_year: "1 Jahr",
      progress: "Fortschritt",
      customer: "Kunde",
      data_validation: "Testergebnis",
      number_of_reports_by_status: "Anzahl von Prüfberichten je Status",
      please_click_tiles_to_choose: "Bitte anklicken um auszuwählen",
      quickfilter: "Schnellfilter",
      screw_length: "Schraubenlänge",
      screw_diameter: "Schraubendurchmesser"
    },
    complete_report: {
      error: "Bitte geben Sie Ihren Namen ein.",
      text: "Bitte geben Sie Ihren Namen ein, um den Prüfbericht zu veröffentlichen.",
      success: "Prüfbericht erfolgreich veröffentlicht"
    }
  }
};
